import React from "react";
import {DepositPhase, DepositState, WithdrawState} from "../../payments/PaymentsReducer";
import {GlobalPayload, OnboardingPagePayload} from "../../contenful/types";
import {RouteComponentProps, withRouter} from "react-router-dom";
import {PaymentDialog, Settings, UserInfo} from "../../http/protocol";
import {initDeposit, showCashier, updateDepositPhase} from "../../payments/DepositActions";
import {AppState} from "../../RootReducer";
import {LoginStatus, Status} from "../../http/Types";
import {Dispatch} from "redux";
import {connect} from "react-redux";
import ChooseAmount from "../deposit/ChooseAmount";
import {t} from "../../i18n";
import CurrencyFormatter from "../../utils/CurrencyFormatter";
import Big from "big.js";
import Loader from "../../layout/Loader";
import {BrandA} from "../buttons/buttons";
import { ReactNode } from "react-markdown";

type SimbetBankInfo = {
    bankAccountName:string;
    bankAccountNumber:string;
    bankName:string;
    bankRoutingNumber:string;
}

interface State {
    phase:number;
    loading:boolean;
}

type AllProps = PropsFromState & PropsFromDispatch & OtherProps;


export class SimbetPaymentComponent extends React.Component<AllProps, State> {
    loadingTimeOut:any;
    constructor(props:AllProps) {
        super(props);

        this.state = {phase:0, loading:true};
    }

    componentDidMount() {

        this.loadingTimeOut = setTimeout(()=> {
            this.setState({loading:false})
        },30000);
    }
    componentWillUnmount() {
        clearTimeout(this.loadingTimeOut)
    }

    renderWithdraw() {
        let withdraw = this.props.withdraw != undefined ? this.props.withdraw : {};
        let phase = withdraw && withdraw.phase;
        return(
            <div className="withdraw-title">
              Coming soon!
            </div>
        )
    }

    handleOnclick() {
        this.props.initDeposit();
        this.setState({phase:1});
    }

    getFormattedAmount() {
        const amount = this.props.deposit.depositDialog && this.props.deposit.depositDialog.payment && this.props.deposit.depositDialog.payment.amount || 0;
        const currency = this.props.activeCurrency  || "";
        let currencyDefenition = this.props.settings && this.props.settings.currencies && this.props.settings.currencies.filter((curr) => {
            return curr.code == currency
        })
        if(currencyDefenition && currencyDefenition[0]) {
            return CurrencyFormatter.formatWithSymbol(currencyDefenition[0], Big(amount))
        } else {
            return "N/A"
        }
    }

    renderDeposit() {
        let phase:number = this.state.phase;
        let dialog:PaymentDialog = this.props.deposit.depositDialog || {};
        let simbetBankInfo:SimbetBankInfo = dialog.customContext;
        if(phase == 0) {
            return (
                <div className="choose-amount-container">
                    <ChooseAmount handleOnClick={() => this.handleOnclick()}/>
                </div>
            )
        }
        if(phase == 1){
            if(simbetBankInfo) {
                return (
                    <div className="choose-amount-container">
                        <div className="deposit-content">
                            <div>
                                <h3>{t("payments.method.bank_transfer.deposit_instructions").replace("|amount|", this.getFormattedAmount())}</h3>
                            </div>
                            <table className="table table-sm table-dark" style={{textAlign:"left"}}>
                                <tbody>
                                    <tr>
                                        <td className="flex-sm-column">{t("payments.method.bank_transfer.bankName")}</td>
                                        <td className="flex-sm-column">{simbetBankInfo.bankName}</td>
                                    </tr>
                                    <tr>
                                        <td> {t("payments.method.bank_transfer.bankAccountName")}</td>
                                        <td>{simbetBankInfo.bankAccountName}</td>
                                    </tr>
                                    <tr>
                                        <td>{t("payments.method.bank_transfer.bankAccountNumber")}</td>
                                        <td>{simbetBankInfo.bankAccountNumber}</td>
                                    </tr>
                                    <tr>
                                        <td>{t("payments.method.bank_transfer.bankRoutingNumber")}</td>
                                        <td>{simbetBankInfo.bankRoutingNumber}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        {this.props.handleClickStartPlaying && <BrandA className={"btn btn-cta full-width large"}  onClick={this.props.handleClickStartPlaying}>{t("global.startPlaying")}</BrandA>}
                    </div>
                )
            } else {
                return (
                    <div className="choose-amount-container">
                        {this.state.loading && <Loader/>}
                        {!this.state.loading && (
                            <div>
                                <div>
                                    <h3>{t("payments.result.ERROR.label")}</h3>
                                </div>
                                <div className="deposit-content">
                                    <p>{t("payments.result.ERROR.message")}</p>
                                </div>
                            </div>
                        )}
                    </div>
                )
            }
        }
    }

    render(): ReactNode | ReactNode[]  {
        if(this.props.type == "withdraw") {
            return this.renderWithdraw()
        }
        if(this.props.type == "deposit") {
            return  this.renderDeposit()
        }
    }
}

interface OtherProps extends RouteComponentProps {
    type: string
    withdraw? : WithdrawState;
    handleClickOk?: () => void;
    handleClickStartPlaying?: () => void;
}

interface PropsFromState {
    deposit: DepositState;
    onboardingpage?: OnboardingPagePayload;

    settings?: Settings;
    registrationStatus: boolean;
    user?: UserInfo;
    show?: boolean;
    activeCurrency?: string;
}

interface PropsFromDispatch {
    fetchProviders? : () => void;
    hide: () => void;
    updatePhase: typeof updateDepositPhase;
    initDeposit: typeof initDeposit;
}


const mapStateToProps = ({payments, contentful, settings, user} : AppState) => {
    let status = false;
    if(user.registration && user.registration.status) {
        if(user.registration.status == Status.SUCCESS) {
            status = true;
        }
    }
    return {
        deposit : payments.deposit,
        onboardingpage: contentful.onboardingpage,
        settings: settings.settings,
        loggedIn : LoginStatus.LOGGED_IN == user.status,
        registrationStatus : status,
        user: user.user,
        show: payments.cashier.showCashierModal,
        activeCurrency: user.activeCurrency
    }
}

const mapDispatchToProps = (dispatch : Dispatch) => (
    {
        initDeposit : () => dispatch(initDeposit() as any),
        hide : () => dispatch(showCashier(false)),
        updatePhase : (phase:DepositPhase) => dispatch(updateDepositPhase(phase))
    }
)

export default connect(mapStateToProps, mapDispatchToProps)(withRouter<AllProps,any>(SimbetPaymentComponent));